/* eslint-disable no-var */
/* eslint-disable no-console */
/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable prettier/prettier */
/* eslint-disable quotes */
/* eslint-disable no-prototype-builtins */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-this-alias */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import { utils } from "./utils";
export class phone {
    static createPhoneValidation(leadWindow, errMsg, currentLocale) {
        utils.addValidationMethod("phoneNanpValid", (value, element) => {
            var _a;
            const currentPhone = (_a = leadWindow.intlTelInputGlobals) === null || _a === void 0 ? void 0 : _a.getInstance(element);
            const selectedCountry = currentPhone
                ? currentPhone.getSelectedCountryData().iso2.toLowerCase()
                : "";
            switch (selectedCountry) {
                case "cl":
                    var chilePhonePattern = new RegExp(/^\d{6,11}$/);
                    // Remove whitespace
                    var phoneNumberClean = value && value.toString().replace(/\s+/g, "").replace(/_+/g, "");
                    // Empty value is OK if it's not required
                    if (phoneNumberClean === "" && !utils.isRequired(element)) {
                        return true;
                    }
                    else {
                        return chilePhonePattern.test(phoneNumberClean);
                    }
                case "pe":
                    var peruPhonePattern = new RegExp(/^\d{7,11}$/);
                    // Remove whitespace
                    var phoneNumberClean = value && value.toString().replace(/\s+/g, "").replace(/_+/g, "");
                    // Empty value is OK if it's not required
                    if (phoneNumberClean === "" && !utils.isRequired(element)) {
                        return true;
                    }
                    else {
                        return peruPhonePattern.test(phoneNumberClean);
                    }
                case "br":
                    var brazilPhonePattern = new RegExp(/^\d{10,11}$/);
                    // Remove whitespace
                    var phoneNumberClean = value &&
                        value
                            .toString()
                            .replace(/\s+/g, "")
                            .replace(/_+/g, "")
                            .replace(/-+/g, "")
                            .replace(/[(|)]+/g, "");
                    // Empty value is OK if it's not required
                    if (phoneNumberClean === "" && !utils.isRequired(element)) {
                        return true;
                    }
                    else {
                        return brazilPhonePattern.test(phoneNumberClean);
                    }
                case "ec":
                    var ecuadorPhonePattern = new RegExp(/^\(\d{2,4}\)\d{4}-\d{4}$/);
                    // Remove whitespace
                    var phoneNumberClean = value && value.toString().replace(/\s+/g, "").replace(/_+/g, "");
                    // Empty value is OK if it's not required
                    if (phoneNumberClean === "" &&
                        !window.DealeronLead.isRequired(element)) {
                        return true;
                    }
                    else {
                        return ecuadorPhonePattern.test(phoneNumberClean);
                    }
                case "py":
                    var paraguayPhonePattern = new RegExp(/^\d{3}-\d{3,6}$/);
                    // Remove whitespace
                    var phoneNumberClean = value && value.toString().replace(/\s+/g, "").replace(/_+/g, "");
                    // Empty value is OK if it's not required
                    if (phoneNumberClean === "" &&
                        !window.DealeronLead.isRequired(element)) {
                        return true;
                    }
                    else {
                        return paraguayPhonePattern.test(phoneNumberClean);
                    }
                default:
                    //pattern takes the mask into account
                    var pattern = new RegExp(/^\(\d{3}\)( )(\d{3})(-)(\d{4})( x[_\d]{1,5})?$/);
                    var pattern2 = new RegExp(/^\(?\d{3}\)?( )?(\d{3})(-)?(\d{4})(\s?x?[_\d]{1,5})?$/);
                    var pattern3 = new RegExp(/^(\d{2})( )?(\d{4})( )?(\d{4})$/);
                    var pattern4 = new RegExp(/^(\d{1,3})(-)?(\d{3})(-)?(\d{4})$/);
                    if ((value === "" ||
                        value == "(___) ___-____ x_____" ||
                        value == "__ ____ ____") &&
                        !utils.isRequired(element)) {
                        return true;
                    }
                    else {
                        return (pattern.test(value) ||
                            pattern2.test(value) ||
                            pattern3.test(value) ||
                            pattern4.test(value));
                    }
            }
        }, errMsg[currentLocale].phoneFormat);
    }
    static createPhoneShortValidation(leadWindow, errMsg, currentLocale) {
        utils.addValidationMethod("phoneShortNanpValid", (value, element) => {
            var _a;
            const currentPhone = (_a = leadWindow.intlTelInputGlobals) === null || _a === void 0 ? void 0 : _a.getInstance(element);
            const selectedCountry = currentPhone
                ? currentPhone.getSelectedCountryData().iso2.toLowerCase()
                : "";
            switch (selectedCountry) {
                case "cl":
                    var chilePhonePattern = new RegExp(/^\d{6,11}$/);
                    // Remove whitespace
                    var phoneNumberClean = value && value.toString().replace(/\s+/g, "").replace(/_+/g, "");
                    // Empty value is OK if it's not required
                    if (phoneNumberClean === "" && !utils.isRequired(element)) {
                        return true;
                    }
                    else {
                        return chilePhonePattern.test(phoneNumberClean);
                    }
                case "pe":
                    var peruPhonePattern = new RegExp(/^\d{7,11}$/);
                    // Remove whitespace
                    var phoneNumberClean = value && value.toString().replace(/\s+/g, "").replace(/_+/g, "");
                    // Empty value is OK if it's not required
                    if (phoneNumberClean === "" && !utils.isRequired(element)) {
                        return true;
                    }
                    else {
                        return peruPhonePattern.test(phoneNumberClean);
                    }
                default:
                    //pattern takes the mask into account
                    var pattern = new RegExp(/^\(\d{3}\)( )(\d{3})(-)(\d{4})$/);
                    var pattern2 = new RegExp(/^\(?\d{3}\)?( )?(\d{3})(-)?(\d{4})$/);
                    var pattern3 = new RegExp(/^(\d{2})( )?(\d{4})( )?(\d{4})$/);
                    var pattern4 = new RegExp(/^(\d{1,3})(-)?(\d{3})(-)?(\d{4})$/);
                    if ((value === "" ||
                        value == "(___) ___-____" ||
                        value == "__ ____ ____") &&
                        !utils.isRequired(element)) {
                        return true;
                    }
                    else {
                        return (pattern.test(value) ||
                            pattern2.test(value) ||
                            pattern3.test(value) ||
                            pattern4.test(value));
                    }
            }
        }, errMsg[currentLocale].phoneShortFormat);
    }
    static createPhoneTypeValidation(errMsg, currentLocale) {
        utils.addValidationMethod("phoneTypeValid", (value, element) => {
            if (utils.isRequired(element) && !value) {
                return false;
            }
            const phoneField = document.querySelector("[data-dlron-type='phone']");
            if (phoneField && phoneField.value) {
                return value !== "";
            }
            return true;
        }, errMsg[currentLocale].phoneTypeRequired);
    }
    static getPhoneFormat(isShort, country) {
        country = country || "";
        switch (country) {
            case "mx":
                return "12 3456 7890";
            case "co":
                return "123-456-7890";
            case "cl":
                return "955 582 857";
            case "br":
                return ["(12) 3456-7890", "(12) 34567-8900"];
            case "ec":
                return ["(12) 1234-1234", "(123) 1234-1234", "(1234) 1234-1234"];
            case "py":
                return ["123-123", "123-1234", "123-12345", "123-123456"];
            case "ca":
            case "us":
            default:
                return isShort ? "(123) 456-7890" : "(123) 456-7890 x5555";
        }
    }
    static getPhoneMask(isShort, country) {
        country = country || "";
        switch (country) {
            case "mx":
                return "99 9999 9999";
            case "co":
                return "999-999-9999";
            case "cl":
                return "999 999[ 999 99]";
            case "br":
                return ["(99) 9999-9999", "(99) 99999-9999"];
            case "ec":
                return ["(99) 9999-9999", "(999) 9999-9999", "(9999) 9999-9999"];
            case "py":
                return ["999-999", "999-9999", "999-99999", "999-999999"];
            case "ca":
            case "us":
            default:
                return isShort
                    ? "(999) 999-9999"
                    : ["(999) 999-9999[ x99999]", "(999) 999-9999"];
        }
    }
}
